import {AxiosResponse} from 'axios';

import {CostChangeReason} from '#bunker/types';
import {AppConfig, GetConfigResponse} from 'api/configs';
import i18n from 'utils/localization/i18n';

export const getCachedData = (): {
    data: AxiosResponse<GetConfigResponse, any>;
    timestamp: number;
} | null => {
    const cachedData = localStorage.getItem('configs');
    return cachedData ? JSON.parse(cachedData) : null;
};

export const getAuthproxyHost = (
    appConfig?: Partial<AppConfig>,
): string | null => appConfig?.authproxyHost ?? null;

export function getReasonsWithLabelsFromTanker(reasons: CostChangeReason[]): CostChangeReason[] {
    return reasons.map(reason => {
        return Object.assign(reason, {label: i18n.print(reason.label)});
    });
}
